import supportApiModule from '../supportApi.module';

class SupportCaseApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    getCase(id) {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.support.name,
            `${this.__env.supportApiUrl}/api/v1/cases/${id}`
        );
    }

    getCases(params) {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.support.name,
            `${this.__env.supportApiUrl}/api/v1/cases`,
            {
                params: params
            }
        );
    }

    createCase(body) {
        return this.apiUtil.postWithBearerAuth(
            this.authenticationConstants.support.name,
            `${this.__env.supportApiUrl}/api/v1/cases`,
            body
        );
    }
}

export default supportApiModule.service(
    'supportCaseApiService',
    SupportCaseApiService
);



// WEBPACK FOOTER //
// ./modules/supportApi/case/supportCaseApi.service.js